module.exports = "/static/assets/87e8b020a5518bc77ca4ff629a09ca37.png";